import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
// import "./App.css"
import ThemeComponent from "./components/theme/ThemeComponent";
import AppRoutes from "./Routes";
import "./App.css";
import "./Global.css";
import { DeleteCustomer } from "./screens/Customers/logic/DeleteCustomer";
import { UnsavedChangesProvider } from "./components/UnsavedChangesContext";
import { PermissionsProvider } from "components/context/permissionsContext";
import { SettingsProvider } from "components/context/settingsContext";
import { store } from "store";
import { Provider } from "react-redux";
import "@fake-db";
import themeConfig from "components/configs/themeConfig";
import { LicenseInfo } from '@mui/x-license';
import { ToastContainer } from "react-toastify";

const RouterContent = () => {

  useEffect(() => {
    const customerToDelete = localStorage.getItem("customerToDelete");
    if (customerToDelete) {
      let result = DeleteCustomer(parseInt(customerToDelete)); // Perform deletion
      console.log(result);
      localStorage.removeItem("customerToDelete");
    }
  }, []);

  useEffect(() => {
    LicenseInfo.setLicenseKey('62b861ddc3657203e9067634f1c514a8Tz0xMjE2NTQsRT0xNzk0NDQxNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=');

    // const MUI_PRO_LICENSE_KEY = process.env.REACT_APP_MUI_PRO_LICENSE_KEY;
    // if (MUI_PRO_LICENSE_KEY) {
    //   LicenseInfo.setLicenseKey(MUI_PRO_LICENSE_KEY);
    // } else {
    //   console.warn('MUI Pro license key not found in environment variables');
    // }
  }, [])
  

  return (
    <PermissionsProvider>    
      <UnsavedChangesProvider>
        <AppRoutes />
      </UnsavedChangesProvider>
    </PermissionsProvider>
  );
};



const App: React.FC = () => {  
  // const { settings } = useSettings();

  const pageSettings = {
    themeColor: 'primary',
    mode: themeConfig.mode,
    skin: themeConfig.skin || 'default',
    layout: themeConfig.layout,
    direction: themeConfig.direction,
    navHidden: themeConfig.navHidden,
    appBarBlur: themeConfig.appBarBlur,
    navCollapsed: themeConfig.navCollapsed,
    contentWidth: themeConfig.contentWidth,
    toastPosition: themeConfig.toastPosition,
    verticalNavToggleType: themeConfig.verticalNavToggleType
  };

  return (
    <>
      <Provider store={store}>
        <SettingsProvider pageSettings={pageSettings}>          
            <ThemeComponent>
              <Router>
                <RouterContent />
              </Router>
              <ToastContainer/>
            </ThemeComponent>
        </SettingsProvider>
      </Provider>
    </>
  );
};

export default App;
